import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions, MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatDialogModule } from '@angular/material/dialog';
import { LayoutModule } from '@angular/cdk/layout';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatTableExporterModule } from 'mat-table-exporter';
const appearance: MatFormFieldDefaultOptions = {
	appearance: 'outline'
};
@NgModule({
	imports: [
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		MatSidenavModule,
		MatToolbarModule,
		MatSelectModule,
		MatListModule,
		MatCardModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatMenuModule,
		MatTabsModule,
		MatCheckboxModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatTableModule,
		MatPaginatorModule,
		MatExpansionModule,
		MatTooltipModule,
		MatSortModule,
		MatStepperModule,
		MatGridListModule,
		MatChipsModule,
		MatTreeModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		LayoutModule,
		MatRippleModule,
		MatDialogModule,
		MatButtonToggleModule,
		DragDropModule,
		MatTableExporterModule
	],
	exports: [
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		MatSidenavModule,
		MatToolbarModule,
		MatSelectModule,
		MatListModule,
		MatCardModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatMenuModule,
		MatTabsModule,
		MatCheckboxModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatTableModule,
		MatPaginatorModule,
		MatExpansionModule,
		MatTooltipModule,
		MatSortModule,
		MatStepperModule,
		MatGridListModule,
		MatChipsModule,
		MatTreeModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		LayoutModule,
		MatRippleModule,
		MatDialogModule,
		MatButtonToggleModule,
		DragDropModule
	],
	providers: [
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: appearance
		}
	]
})
export class MaterialModule {}
